/**
 * 顶部角色栏 (rsLQgK)。
 *
 * 原站的显示规则（从 kt 组件还原）：
 *   showLoginBtn    = ready ? (!role && !account) : true
 *   showRoleSwitch  = !!account
 *   showLogoutBtn   = role || account
 * 只有在 account 渠道下才显示"切换角色"图标；文案为 role.nickName。
 */
import { COPY, type AccountState } from '../../types';
import iconSwitch from '/assets/img/icon-switch.png';
import iconLogout from '/assets/img/icon-logout.png';

export interface QuestHeaderProps {
  account: AccountState;
  onLogin: () => void;
  onSwitchRole: () => void;
  onLogout: () => void;
  /** 位于 App 内嵌壳（如 Skland）时不显示登录入口 */
  inContainer?: boolean;
}

export function QuestHeader({ account, onLogin, onSwitchRole, onLogout, inContainer }: QuestHeaderProps) {
  const { ready, role, account: accountInfo } = account;
  const channel = 'account';

  const showLoginBtn = inContainer ? false : ready ? !role && !accountInfo : true;
  const showRoleSwitch = inContainer ? true : !!accountInfo;
  const showLogoutBtn = inContainer ? false : !!(role || accountInfo);

  return (
    <div className="roleInfoWrapper">
      {showLoginBtn ? (
        <div className="roleInfo">
          <button type="button" onClick={onLogin}>
            {COPY.login}
          </button>
        </div>
      ) : (
        <>
          <div className="roleInfo">
            <button type="button" onClick={showRoleSwitch ? onSwitchRole : undefined}>
              {role ? role.nickName : COPY.noRole}
            </button>
          </div>
          <div className="roleActionGroup">
            {channel === 'account' && (
              <button type="button" className="roleAction roleSwitch" onClick={onSwitchRole} aria-label={COPY.switchRole}>
                <img src={iconSwitch} alt="" />
              </button>
            )}
            {showLogoutBtn && (
              <button type="button" className="roleAction" onClick={onLogout} aria-label={COPY.logout}>
                <img src={iconLogout} alt="" />
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
